import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ComparePage } from '@/features/dokless-compare/compare-page';
import { SHOW } from '@/features/dokless-compare/model';

// «Confronto con Dokless» (ADR 0070): the shadow trial, shipment by shipment.
// `?show=` filters, `?shipment=<id>` keeps one shipment (S06's link).
export const Route = createFileRoute('/_app/shipments/compare')({
  validateSearch: z.object({
    show: z.enum(SHOW).optional(),
    shipment: z.string().max(36).optional(),
  }),
  component: ComparePage,
});
